import { createContext, useContext, useState } from "react";

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [alert, setAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState(null);

  return (
    <GlobalContext.Provider value={{alert, alertMsg, setAlert, setAlertMsg}}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobalStates = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error("useGlobalStates must be used within a GlobalProvider");
  }

  return context;
};
